import precision from '../assets/precision.png';
import { useSharedState } from '../hooks/useSharedState';
import styles from './LocateMe.module.css';

export function LocateMe() {

    const [latitude, setLatitude] = useSharedState('latitude', '');
    const [longitude, setLongitude] = useSharedState('longitude', '');

    const toggleGeolocalization = () => {

        if(latitude && longitude) {
            setLatitude('');
            setLongitude('');
            return;
        }
        
        const success: PositionCallback = (position) => {

            const lat = position.coords.latitude.toString();
            const lng = position.coords.longitude.toString();

          setLatitude(lat);
          setLongitude(lng);

          console.log("pos: ", lat, lng);
        }
      
        const error = (error: GeolocationPositionError) => {
          console.error(error);
        }
      
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success, error);
        } else {

        }
    }

    return <div onClick={toggleGeolocalization} className={[styles.container, latitude && longitude ? styles.selected : ''].join(' ')}>

        <img src={precision} width="30" height="30" />
        Autour de moi

    </div>;

}